<ng-container>
    <div mat-dialog-content class="reminder-popup-mat-dialog-content">
        <div class="title-container" id="confirmIconCol">
            <i class="fa fa-exclamation-triangle color-primary fa-lg" aria-hidden="true"></i>
            <p class="title">{{title}}</p>
        </div>
        <div class="m-t-6">
            <div class="content-text" [innerHtml]="htmlContent" id="content-div"></div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-action-btns">
        <button id="close-btn" class="btn color-primary" (click)="closeDialog()">CLOSE</button>
    </div>
</ng-container>